module.exports = __webpack_public_path__ + "b2d38dfeda0a095de5cb36ef5237c8ea.jpg";